const ru = {
  poweredBy: 'Работает на',
  firstBehaviorAgent: 'Первый агент по поведению и UX на OpenAI',
  ratings: 'Оценки',
  productivity: 'Продуктивность',
  category: 'Категория',
  conversations: 'Разговоры',
  download: 'Скачать',
  inDevelopment: 'В разработке',
  open: 'Открыть',
};

export default ru;
